import { render, staticRenderFns } from "./TempList.vue?vue&type=template&id=3168fcf4"
import script from "./TempList.vue?vue&type=script&lang=js"
export * from "./TempList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports